export default __webpack_public_path__ + "static/media/biomechanics.df852498.jpg";